import { render, staticRenderFns } from "./sellSincerityDia.vue?vue&type=template&id=1bdfcd56&scoped=true"
import script from "./sellSincerityDia.vue?vue&type=script&lang=js"
export * from "./sellSincerityDia.vue?vue&type=script&lang=js"
import style0 from "./sellSincerityDia.vue?vue&type=style&index=0&id=1bdfcd56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdfcd56",
  null
  
)

export default component.exports